/** Hero Block JS */

document.addEventListener('DOMContentLoaded', () => {
    const animated = document.querySelectorAll('[data-animation]');
    if (!animated.length) return;

    animated.forEach(el => {
        requestAnimationFrame(() => {
            el.classList.add('is-loaded');
        });
    });
});
